import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import services from "../../services";
import Deadline_ScrollBar from "../Sections/Deadline_ScrollBar/Deadline_ScrollBar";
import Main from "./main/main";
import Nav from "./nav/nav";
//import HeroSection from "../Sections/HeroSection/HeroSection";
import "./services.css";
let previd = null;
let initialelem = null;
let initialelem2 = null;

function highlight(id) {
  if (previd != null || previd === 0) {
    document.getElementById(`maincat${previd}`)?.classList.remove("selected2");
    document.getElementById(`maincat${id}`)?.classList.add("selected2");
    document
      .getElementById(`lgmaincat${previd}`)
      ?.classList.remove("lgselected2");
    document.getElementById(`lgmaincat${id}`)?.classList.add("lgselected2");
    previd = id;
  } else {
    document.getElementById(`maincat${id}`)?.classList.add("selected2");
    document.getElementById(`lgmaincat${id}`)?.classList.add("lgselected2");
    previd = id;
  }
}

function changeactive(id) {
  document
    .getElementById(`mobbutton${initialelem}`)
    .classList.remove("selected");
  document.getElementById(`mobbutton${id}`).classList.add("selected");
  initialelem = id;
  document
    .getElementById(`lgcatbutton${initialelem2}`)
    .classList.remove("lgselected1");
  document.getElementById(`lgcatbutton${id}`).classList.add("lgselected1");
  initialelem2 = id;
}

function Services(props) {
  const { search } = useLocation();
  let { id } = queryString.parse(search);
  var [content, setContent] = useState(services[id - 1]);

  if (id == null) {
    id = 1;
  }
  // debugger;

  const [categorySelected, setCategorySelected] = useState(
    services[id - 1].title
  );
  useEffect(() => {
    initialelem = id;
    initialelem2 = id;
    document
      .getElementById(`mobbutton${initialelem}`)
      .classList.add("selected");
    document
      .getElementById(`lgcatbutton${initialelem}`)
      .classList.add("lgselected1");
  }, []);
  function mainContent(service) {
    setContent(service);
  }
  const categoryChangeHandler = (category) => {
    setCategorySelected(category);
    const categoryClasses = document.getElementsByClassName("lgmaincat");
    for (let i = 0; i < categoryClasses.length; i++) {
      document
        .getElementById(`lgmaincat${i + 1}`)
        ?.classList.remove("lgselected2");
    }
    document.getElementById(`lgmaincat0`)?.classList.add("lgselected2");
  };
  return (
    <div className="services" style={{ height: "100vh" }}>
      {/* {props.showModal && <HeroSection setShowModal={props?.setShowModal} />} */}
      <Deadline_ScrollBar />
      <Nav
        services={services}
        mainContent={mainContent}
        categoryChange={categoryChangeHandler}
      />
      <div className="vertical-bars">
        <div className="darkgreen-bar"></div>
        <div className="lightgreen-bar"></div>
      </div>
      <Main
        category={categorySelected}
        service={content}
        services={content}
        serv1={services}
        mainContent={mainContent}
      />
      <div className="sidebar"></div>
    </div>
  );
}
export { highlight, changeactive };
export default Services;
